import { useEffect, useContext } from 'react';
import { UserContext } from '@/context/user';

export const useContextReady = (onReady: any) => {
  const {
    ready,
  } = useContext(UserContext)

  useEffect(() => {
    if (ready === true) {
      if (onReady) {
        try {
          onReady()
        } catch(e) { }
      }
    }
  }, [ready])
}